import React, { useState, useCallback } from 'react';
import Inmuebles, { CreateActionInfo } from './Inmuebles';
import IngresosGastos from './IngresosGastos';
import ActionButton from '../components/common/ActionButton';
import { FaPlus } from 'react-icons/fa';
import './Products.css';

const tabItems = [
  { id: 'inmuebles', label: 'Inmuebles' },
  { id: 'ingresos-gastos', label: 'Ingresos y Gastos' },
] as const;

type TabId = typeof tabItems[number]['id'];

const SeguimientoCra: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('inmuebles');
  const [actionInfo, setActionInfo] = useState<CreateActionInfo | null>(null);

  const handleRegisterAction = useCallback((info: CreateActionInfo) => {
    setActionInfo(info);
  }, []);

  return (
    <div>
      <div className="tabs">
        {tabItems.map((t) => (
          <button
            key={t.id}
            className={`tab ${activeTab === t.id ? 'active' : ''}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
          </button>
        ))}
        {actionInfo?.visible && (
          <div className="tab-actions">
            <ActionButton
              icon={FaPlus}
              text={actionInfo.label}
              onClick={actionInfo.action}
              variant="primary"
            />
          </div>
        )}
      </div>
      {activeTab === 'inmuebles'
        ? <Inmuebles onRegisterAction={handleRegisterAction} />
        : <IngresosGastos onRegisterAction={handleRegisterAction} />
      }
    </div>
  );
};

export default SeguimientoCra;
